import { ITag } from "@/shared/model/tag.model";
import { ICustomer } from "@/shared/model/customer.model";
import { ICampaignDate } from "@/shared/model/campaign-date.model";
import { ICampaignLink } from "@/shared/model/campaign-link.model";
import { ICampaignAssignment } from "@/shared/model/campaign-assignment.model";
import { AbstractEntity } from "@/shared/model/abstract-entity.model";
import { ICampaignKeyword } from "@/shared/model/campaign-keyword.model";
import { IUser } from "@/shared/model/user.model";

export interface ICampaign extends AbstractEntity {
  id?: number;
  name?: string;
  keywords?: ICampaignKeyword[] | null;
  description?: string | null;
  startDate?: string;
  endDate?: string;
  released?: boolean;
  important?: boolean;
  publicationsCount?: number | null;
  goalFacebookPosts?: number | null;
  goalInstagramPosts?: number | null;
  goalInstagramStories?: number | null;
  goalYoutubeContents?: number | null;
  goalWebsiteEntries?: number | null;
  goalTikTokPosts?: number | null;
  goalAds?: number | null;
  goalPublicationsSum?: number | null;
  sponsoredPublicationsSum?: number | null;
  comment?: string | null;
  assets?: string | null;
  targetUrl?: string | null;
  finalPrice?: number | null;
  active?: boolean | null;
  tags?: ITag[] | null;
  customers?: ICustomer[] | null;
  dates?: ICampaignDate[] | null;
  links?: ICampaignLink[] | null;
  dateRange?: [string, string];
  notifiedUsers?: IUser[] | null;
}

export class Campaign implements ICampaign {
  constructor(
    public id?: number,
    public name?: string,
    public keywords?: ICampaignKeyword[] | null,
    public description?: string | null,
    public startDate?: string,
    public endDate?: string,
    public released?: boolean,
    public important?: boolean,
    public publicationsCount?: number | null,
    public goalFacebookPosts?: number | null,
    public goalInstagramPosts?: number | null,
    public goalInstagramStories?: number | null,
    public goalYoutubeContents?: number | null,
    public goalWebsiteEntries?: number | null,
    public goalTikTokPosts?: number | null,
    public goalAds?: number | null,
    public goalPublicationsSum?: number | null,
    public sponsoredPublicationsSum?: number | null,
    public comment?: string | null,
    public assets?: string | null,
    public targetUrl?: string | null,
    public finalPrice?: number | null,
    public active?: boolean | null,
    public tags?: ITag[] | null,
    public customers?: ICustomer[] | null,
    public dates?: ICampaignDate[] | null,
    public links?: ICampaignLink[] | null,
    public assignments?: ICampaignAssignment[] | null,
    public notifiedUsers?: IUser[] | null,
  ) {
    this.released = this.released ?? false;
    this.active = this.active ?? false;
  }
}
